'use es6';

import { createAction } from 'flux-actions';
import invariant from 'react-utils/invariant';
import * as RequestStatusTypes from 'MeetingsBase/constants/RequestStatusTypes';

function getStatusIndex(type) {
  var statusIndex = type ? type.lastIndexOf('_') : -1;

  if (statusIndex === -1) {
    throw new Error("exected an request action type in the form of ${NAMESPACE}_${REQUEST_STATUS} but received " + type);
  }

  return statusIndex;
}

function getRequestNamespace(type) {
  var statusIndex = getStatusIndex(type);
  return type.substring(0, statusIndex);
}

function getRequestStatus(type) {
  var statusIndex = getStatusIndex(type);
  var requestStatus = type.substring(statusIndex + 1);
  invariant(Object.prototype.hasOwnProperty.call(RequestStatusTypes, requestStatus), 'expected `requestStatus` to be defined in `MeetingsBase/constants/RequestStatusTypes` but got `%s`', requestStatus);
  return requestStatus;
}

export function createRequestStatusMeta(type) {
  var namespace = getRequestNamespace(type);
  var requestStatus = getRequestStatus(type);
  return {
    request: {
      key: namespace,
      status: requestStatus
    }
  };
}
export function createRequestAction(type) {
  var payloadCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var metadataCreator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return {};
  };
  return createAction(type, payloadCreator, function () {
    return Object.assign({}, metadataCreator.apply(void 0, arguments), {}, createRequestStatusMeta(type));
  });
}